// Hero — centered, image-free typographic statement. The title is the focal
// point; gold rules, an italic accent, and an ornamental divider carry the
// "eye-catching, luxe" feel without any photo.
export function HeroSection({ onBookNow }) {
  const pillars = [
    { value: "Braids", label: "Knotless & Boho" },
    { value: "Wigs", label: "Custom Installs" },
    { value: "Locs", label: "Retwist & Care" },
    { value: "Twists", label: "Island & More" },
  ];

  return (
    <section id="hero" className="hero-section hero-section--centered">
      <div className="hero-section__inner container">
        <div className="hero-section__copy">
          <p className="eyebrow hero-section__eyebrow">
            <span className="hero-section__eyebrow-rule" aria-hidden="true" />
            Canton · Hair Studio
            <span className="hero-section__eyebrow-rule hero-section__eyebrow-rule--right" aria-hidden="true" />
          </p>

          <h1 className="hero-section__title">
            Where beauty<br />becomes <em>art.</em>
          </h1>

          <div className="hero-divider" aria-hidden="true">
            <span className="hero-divider__line" />
            <span className="hero-divider__mark">&#10022;</span>
            <span className="hero-divider__line" />
          </div>

          <p className="hero-section__lede">
            An intimate studio for bespoke styling, color, and bridal —
            handcrafted by Trinya Marieee.
          </p>

          <div className="hero-section__actions">
            <button className="button button--primary" onClick={onBookNow}>
              Book Your Experience
            </button>
            <button
              className="button--link"
              onClick={() => document.getElementById("services")?.scrollIntoView({ behavior: "smooth" })}
            >
              Explore services
              <span aria-hidden="true">→</span>
            </button>
          </div>
        </div>
      </div>

      <div className="hero-stats">
        {pillars.map((item) => (
          <div key={item.label} className="hero-stats__item">
            <p className="hero-stats__value">{item.value}</p>
            <p className="hero-stats__label">{item.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
